"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
const utils_1 = require("@8base/utils");
const getFieldSchemaFeatures = ({ tableName, appName, fieldName, tableId, fieldId }, tablesList) => {
    if (!!tableId && !!fieldId) {
        const table = utils_1.tablesListSelectors.getTableById(tablesList, tableId);
        const field = utils_1.tableSelectors.getFieldById(table, fieldId);
        return utils_1.tableFieldSelectors.getSchemaFeatures(field);
    }
    else if (!!tableName && !!fieldName) {
        const table = utils_1.tablesListSelectors.getTableByName(tablesList, tableName, appName);
        const field = utils_1.tableSelectors.getFieldByName(table, fieldName);
        return utils_1.tableFieldSelectors.getSchemaFeatures(field);
    }
    return {};
};
const getFieldDataFeatures = ({ tableName, appName, fieldName, tableId, fieldId }, tablesList) => {
    if (!!tableId && !!fieldId) {
        const table = utils_1.tablesListSelectors.getTableById(tablesList, tableId);
        const field = utils_1.tableSelectors.getFieldById(table, fieldId);
        return utils_1.tableFieldSelectors.getDataFeatures(field);
    }
    else if (!!tableName && !!fieldName) {
        const table = utils_1.tablesListSelectors.getTableByName(tablesList, tableName, appName);
        const field = utils_1.tableSelectors.getFieldByName(table, fieldName);
        return utils_1.tableFieldSelectors.getDataFeatures(field);
    }
    return {};
};
const getTableSchemaFeatures = ({ tableName, appName, tableId }, tablesList) => {
    if (!!tableId) {
        const table = utils_1.tablesListSelectors.getTableById(tablesList, tableId);
        return utils_1.tableSelectors.getSchemaFeatures(table);
    }
    else if (!!tableName) {
        const table = utils_1.tablesListSelectors.getTableByName(tablesList, tableName, appName);
        return utils_1.tableSelectors.getSchemaFeatures(table);
    }
    return {};
};
const getTableDataFeatures = ({ tableName, appName, tableId }, tablesList) => {
    if (!!tableId) {
        const table = utils_1.tablesListSelectors.getTableById(tablesList, tableId);
        return utils_1.tableSelectors.getDataFeatures(table);
    }
    else if (!!tableName) {
        const table = utils_1.tablesListSelectors.getTableByName(tablesList, tableName, appName);
        return utils_1.tableSelectors.getDataFeatures(table);
    }
    return {};
};
const Features = {
    schema: {
        isUpdateTableAllowed: ({ tableName, appName, tableId, fieldName }, tablesList) => {
            const schemaFeatures = getTableSchemaFeatures({ tableName, appName, tableId }, tablesList);
            return ramda_1.pathOr(false, ['update', fieldName], schemaFeatures);
        },
        isCreateFieldByTypeAllowed: ({ tableName, appName, tableId, fieldType }, tablesList) => {
            const schemaFeatures = getTableSchemaFeatures({ tableName, appName, tableId }, tablesList);
            return ramda_1.pathOr(false, ['create', fieldType], schemaFeatures);
        },
        isCreateFieldAllowed: ({ tableName, appName, tableId }, tablesList) => {
            return Object.keys(utils_1.FIELD_TYPE).reduce((result, fieldType) => result || Features.schema.isCreateFieldByTypeAllowed({ tableName, appName, tableId, fieldType }, tablesList), false);
        },
        isUpdateFieldAllowed: (options, tablesList) => {
            const schemaFeatures = getFieldSchemaFeatures(options, tablesList);
            return ramda_1.propOr(false, 'update', schemaFeatures);
        },
        isDeleteFieldAllowed: (options, tablesList) => {
            const schemaFeatures = getFieldSchemaFeatures(options, tablesList);
            return ramda_1.propOr(false, 'delete', schemaFeatures);
        },
    },
    data: {
        isCreateRecordAllowed: (options, tablesList) => {
            const dataFeatures = getTableDataFeatures(options, tablesList);
            return ramda_1.propOr(false, 'create', dataFeatures);
        },
        isUpdateRecordAllowed: (options, tablesList) => {
            const dataFeatures = getTableDataFeatures(options, tablesList);
            return ramda_1.propOr(false, 'update', dataFeatures);
        },
        isDeleteRecordAllowed: (options, tablesList) => {
            const dataFeatures = getTableDataFeatures(options, tablesList);
            return ramda_1.propOr(false, 'delete', dataFeatures);
        },
        isCreateFieldAllowed: (options, tablesList) => {
            const dataFeatures = getFieldDataFeatures(options, tablesList);
            return ramda_1.propOr(false, 'create', dataFeatures);
        },
        isUpdateFieldAllowed: (options, tablesList) => {
            const dataFeatures = getFieldDataFeatures(options, tablesList);
            return ramda_1.propOr(false, 'update', dataFeatures);
        },
    },
};
exports.Features = Features;
//# sourceMappingURL=Features.js.map